export default "__VITE_ASSET__c8be5e0a__"